import React from 'react';
import { Card, Badge } from 'react-bootstrap';
import LeadCard from './LeadCard';
import { Droppable } from './Droppable';

const MarketingKanbanColumn = ({ column, leads, onCardClick, onWhatsAppClick, isDropDisabled }) => {
    return (
        <Card className="kanban-column shadow-sm">
            <Card.Header
                className="d-flex justify-content-between align-items-center"
                style={{ backgroundColor: column.color, color: 'white' }}
            >
                <span className="fw-bold">{column.title}</span>
                <Badge bg="light" text="dark" pill>{leads.length}</Badge>
            </Card.Header>
            <Card.Body className="kanban-column-body p-0">
                <Droppable droppableId={column.id} isDropDisabled={isDropDisabled}>
                    {(provided, snapshot) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            className="kanban-column-content"
                            style={{
                                background: snapshot.isDraggingOver ? '#e9ecef' : 'transparent',
                                minHeight: '500px',
                                padding: '8px',
                            }}
                        >
                            {leads.map((lead, index) => (
                                <LeadCard
                                    key={lead.id}
                                    lead={lead}
                                    index={index}
                                    onClick={onCardClick}
                                    onWhatsAppClick={onWhatsAppClick} // ← NOVO
                                />
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </Card.Body>
        </Card>
    );
};

export default MarketingKanbanColumn;
